import '../../styles-new/pages/404.scss';